import AddressManager from "../Shared/AddressManager";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
const i18n = require('LanguageData');

const {ccclass, property} = cc._decorator;

@ccclass
export default class VerificationUI extends cc.Component {
    @property(cc.Label)
    lbPayType: cc.Label = null
    
    @property(cc.EditBox)
    ebPayNumber: cc.EditBox = null

    @property(cc.EditBox)
    ebCode: cc.EditBox = null

    @property(cc.Sprite)
    spCode: cc.Sprite = null

    @property(cc.Node)
    nodeIconBank: cc.Node = null

    @property(cc.Node)
    nodeIconAlipay: cc.Node = null

    @property({type: Function, visible: false})
    callback: Function = null

    @property(cc.Integer)
    _payType: number = 0
    
    @property({type: cc.Integer})
    set payType (value) {
        this._payType = value
        if (this._payType === 0) {
            this.lbPayType.string = i18n.t("login_text.bank_card")
            this.ebPayNumber.placeholder = i18n.t("login_text.enter_bank_card")
            this.ebPayNumber.inputMode = cc.EditBox.InputMode.NUMERIC
            this.ebPayNumber.node.getChildByName("PLACEHOLDER_LABEL").getComponent(cc.Label).overflow = cc.Label.Overflow.SHRINK
            this.nodeIconBank.active = true
            this.nodeIconAlipay.active = false
        }else if (this._payType === 1){
            this.lbPayType.string = i18n.t("login_text.alipay")
            this.ebPayNumber.placeholder = i18n.t("login_text.enter_alipay")
            this.ebPayNumber.inputMode = cc.EditBox.InputMode.SINGLE_LINE
            this.ebPayNumber.node.getChildByName("PLACEHOLDER_LABEL").getComponent(cc.Label).overflow = cc.Label.Overflow.SHRINK
            this.nodeIconBank.active = false
            this.nodeIconAlipay.active = true
        }
    }

    get payType () {
        return this._payType
    }

    @property({type: cc.String})
    set payNumber (value) {
        this.ebPayNumber.placeholder += "（" + value + "）"
    }

    get payNumber () {
        return this.ebPayNumber ? this.ebPayNumber.string : ""
    }
    
    private _codeId: number = 0

    start () {
        this.refreshCodeImage()
    }

    onBtnClick (event, userData) {
        if (userData === "confirm") {
            if (this.ebPayNumber.string === "") {
                if (this._payType === 0) {
                    UIManager.showToastUI(i18n.t("login_text.bind_bank"), Global.ToastType.Warnning)
                }else if (this._payType === 1){
                    UIManager.showToastUI(i18n.t("login_text.bind_alipay"), Global.ToastType.Warnning)
                }
                return
            }
            if (this.ebCode.string === "") {
                UIManager.showToastUI(i18n.t("login_text.enter_code"), Global.ToastType.Warnning)
                return
            }
            this.callback && this.callback(this.ebPayNumber.string, this.ebCode.string, this._codeId)
            this.node.destroy()
        }else if (userData === "close") {
            this.node.destroy()
        }else if (userData === "code") {
            this.refreshCodeImage()
        }
    }

    private refreshCodeImage () {
        this._codeId = Math.floor(Math.random() * 1000)
        let remoteUrl = AddressManager.getServerAdress() + "/api/user/generator-code?code_id=" + this._codeId.toString();
        cc.loader.load({url: remoteUrl, type: 'png'}, function (err, texture:cc.Texture2D) {
            if (!err && this.node) {
                var spriteFrame = new cc.SpriteFrame(texture)
                this.spCode.spriteFrame = null
                this.spCode.spriteFrame = spriteFrame
            }
        }.bind(this));
    }
}
